<template>
    <v-row>
        <v-col cols="12" sm="12" md="12" lg="12" xl="12">
            <v-text-field v-model="search" label="Buscar producto para asignar precio" append-icon="fas fa-search"
                filled dense class="mt-2 mb--2" hide-details @keyup.enter.native="searchProduct">
            </v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="12" xl="12">
            <v-simple-table fixed-header class="elevation-1" dense height="720">
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left primary white--text font-weight-black">Nombre</th>
                            <th class="text-left primary white--text font-weight-black">Unidad venta</th>
                            <th class="text-left primary white--text font-weight-black">Precio minimo de venta</th>
                            <th class="text-left primary white--text font-weight-black">Precio venta</th>
                            <th class="text-left primary white--text font-weight-black" v-if="mode == 'edit'">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in searchProduct" :key="item.id">
                            <td class="dark--text text--darken-4 font-weight-black">
                                <p class="h4 font-weight-black">{{ item.productoName }} - {{  item.productoDescripcion }}</p>
                            </td>
                            <td class="blue--text text--darken-4 font-weight-black">
                                <p class="h4 font-weight-black text-uppercase">{{ item.tipoUnidad.nombre }}</p>
                            </td>
                            <td>
                                <ValidationProvider rules="decimal" v-slot="{ errors, valid }" :immediate="true">
                                    <v-text-field v-model="item.minPrice" type="number" label="Precio minimo" class="mt-3"
                                        outlined persistent-hint prepend-inner-icon="fas fa-dollar-sign" required
                                        :error-messages="errors" :success="valid" suffix="MXN">
                                    </v-text-field>
                                </ValidationProvider>
                            </td>
                            <td>
                                <ValidationProvider rules="decimal" v-slot="{ errors, valid }" :immediate="true">
                                    <v-text-field v-model="item.precioVenta" type="number" label="Precio" class="mt-3"
                                        outlined persistent-hint prepend-inner-icon="fas fa-dollar-sign" required
                                        :error-messages="errors" :success="valid" suffix="MXN">
                                    </v-text-field>
                                </ValidationProvider>
                            </td>
                            <td v-if="mode == 'edit' && item.id != null">
                                <v-btn color="error" small class="pa-2" @click.prevent="deleteProductPrice(item)">
                                    <v-icon small>fas fa-trash-alt</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-col>
    </v-row>
</template>
<script>
import ProductoListaPrecioDataService from '@/service/producto/ProductoListaPrecioDataService';
import { ValidationProvider } from 'vee-validate';

export default {
    name: 'addListaPrice',
    props: {
        cart: { type: Boolean, default: false },
        mode: { type: String, default: 'add' },
        products: { type: Array, default: () => [] },
        listProductPrice: { type: Array, default: () => [] },
    },
    data() {
        return {
            search: '',
            productoListaPrecio: []
        }
    },
    methods: {
        generateByProduct(element){
            return {
                id: null,
                productoId: element.id,
                productoName: element.nombre,
                productoDescripcion: element.descripcion,
                tipoUnidad: element.tipoUnidad,
                listaPrecioId: null,
                precioVenta: null,
                minPrice: null,
                actual: true,
                eliminado: false
            };
            
        },
        generateProductPrice(products) {
            this.productoListaPrecio = products.map(product => this.generateByProduct(product));
        },
      
        checkListProductPrice(listProductPrice) {
            this.products.forEach(element => {
                let exist = listProductPrice.find(item => item.productoId == element.id);
                if(!exist){
                    this.productoListaPrecio.push(this.generateByProduct(element));
                } else {
                    const elementFound = this.generateByProduct(element);
                    elementFound.precioVenta = exist.precioVenta;
                    elementFound.minPrice = exist.minPrice;
                    elementFound.listaPrecioId = exist.id;
                    elementFound.id = exist.id;
                    this.productoListaPrecio.push(elementFound);
                }
            });
            this.productoListaPrecio.sort((a, b) => b.precioVenta - a.precioVenta);
        },
        deleteProductPrice(productPrice) {
            this.$swal.fire({
                title: `Estas seguro de eliminar este producto y su precio de venta?`,
                icon: 'warning',
                html: `<h3 class="blue--text text--darken-4 font-weight-black text-uppercase mb-1"><strong>Producto: ${productPrice.productoName} - ${productPrice.productoDescripcion} </strong></h3>
                Precio venta: $ ${productPrice.precioVenta} <br> Precio minimo: $ ${productPrice.minPrice}`,
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, eliminar!'
            }).then((result) => {
                if(!result.isConfirmed) return;
                ProductoListaPrecioDataService.cancelProductPrice(productPrice.id).then(() => {
                    this.productoListaPrecio = this.productoListaPrecio.filter(item => item.id != productPrice.id);
                    this.$swal.fire({ icon: 'success', title: 'Eliminado!', text: 'El producto fue eliminado con exito.', showConfirmButton: false, timer: 5000 })
                }).catch(err => {
                    this.$swal.fire({ icon: 'error', title: 'Error', html: err.response.data, showConfirmButton: false, timer: 5000 })
                })
            }).catch(err => {
                this.$swal.fire({ icon: 'error', title: 'Error', html: err.response.data, showConfirmButton: false, timer: 5000 })
            })
        },
        emitDataProductPrice(productPrice) {
            this.$emit('addProductPrice', productPrice);
        }
    },
    watch: {
        products: function (newVal, oldVal) {
            if(this.mode == 'add'){
                this.generateProductPrice(newVal);
            }
        },
        productoListaPrecio: function (newVal, oldVal) {
            this.emitDataProductPrice(newVal);
        },
        listProductPrice: function (newVal, oldVal) {
            this.checkListProductPrice(newVal);
        }
    },
    computed: {
        searchProduct() {
            if (this.search == '') return this.productoListaPrecio
            return this.productoListaPrecio.filter((item) => {
                return item.productoName.toLowerCase().includes(this.search.toLowerCase())
            })
        }
    },

}
</script>